import { useState } from "react";

export default function NewsletterCTA() {
  const [email, setEmail] = useState("");
  const [phoneAlt, setPhoneAlt] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (phoneAlt.trim()) {
      setStatus("success");
      setEmail("");
      setPhoneAlt("");
      return;
    }

    if (!email.trim()) {
      setErrorMsg("请输入您的邮箱地址");
      setStatus("error");
      return;
    }

    setLoading(true);
    setErrorMsg("");

    try {
      const formData = new FormData(e.currentTarget);
      const response = await fetch("https://readdy.ai/api/form/d9njm8obdkpk99j7gkqg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || responseText;

      if (response.ok && parsed?.code === "OK") {
        setStatus("success");
        setEmail("");
        setPhoneAlt("");
      } else if (typeof serverMsg === "string" && serverMsg.includes("spam")) {
        setErrorMsg("订阅失败，请稍后重试");
        setStatus("error");
      } else {
        setErrorMsg(typeof serverMsg === "string" ? serverMsg : "订阅失败，请稍后重试");
        setStatus("error");
      }
    } catch {
      setErrorMsg("网络错误，请检查网络后重试");
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative w-full py-14 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20background%20with%20warm%20golden%20and%20amber%20light%20rays%20streaming%20through%20dark%20space%20soft%20bokeh%20effects%20elegant%20minimalist%20composition%20movie%20theater%20atmosphere%20premium%20feel&width=1600&height=500&seq=newsletter-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/80"></div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white font-heading mb-3">
          订阅蓝莓影院更新通知
        </h2>
        <p className="text-white/70 text-sm md:text-base mb-6 max-w-md mx-auto">
          第一时间获取最新影片上线、热门推荐和独家专题内容
        </p>
        <form
          data-readdy-form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="phone_alt"
            autoComplete="off"
            tabIndex={-1}
            aria-hidden="true"
            readOnly
            className="anti-spam-field"
            value={phoneAlt}
            onChange={(e) => setPhoneAlt(e.target.value)}
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入您的邮箱地址"
            className="w-full sm:flex-1 px-4 py-3 rounded-full bg-white/15 border border-white/20 text-white placeholder-white/50 text-sm focus:outline-none focus:border-primary-400 transition-colors"
            required
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full sm:w-auto px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors disabled:opacity-50"
          >
            {loading ? "提交中..." : "立即订阅"}
          </button>
        </form>
        {status === "success" && (
          <p className="text-green-400 text-sm mt-3">订阅成功！感谢您的关注。</p>
        )}
        {status === "error" && (
          <p className="text-red-400 text-sm mt-3">{errorMsg}</p>
        )}
        <p className="text-white/40 text-xs mt-3">无需付费，随时可取消订阅</p>
      </div>
    </section>
  );
}